import styled from '@emotion/styled';

import { SPACING, MEDIA_QUERY, COLORS, COLORS3 } from '@zola/zola-ui/src/styles/emotion';

import {
  Z_INDEX_MAP,
  Z_INDEX_NAV_OVERLAY_KEY,
} from 'components/publicWebsiteV2/util/zIndexConstants';

export const ICON_SIZE = 19;

/* Product has requested that we put dismissable on pause; Leaving in code to activate later */
// const calcPaddLeft = (value: string) => `${Number(value.slice(0, -2)) + ICON_SIZE}px`;

export const Container = styled('div', {
  shouldForwardProp: prop =>
    !['color', 'isDarkMode', 'isAnimating', 'height'].includes(prop as string),
})<{ isDarkMode: boolean; color: string; isAnimating: boolean; height: number }>`
  position: sticky;
  top: 0;
  margin-top: 0;
  z-index: ${Z_INDEX_MAP[Z_INDEX_NAV_OVERLAY_KEY]};
  padding: ${SPACING.SM};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  transition: top 1s, margin-top 1s;
  ${({ isDarkMode, color }) =>
    isDarkMode
      ? `
      color: ${COLORS3.BLACK_100};
      background-color: ${COLORS.WHITE};
    `
      : `
      background-color: #${color};
      color: ${COLORS.WHITE};
    `}
  ${({ isAnimating, height }) =>
    isAnimating &&
    `
    top: -${height}px;
    margin-top: -${height}px;
  `}

  ${MEDIA_QUERY.DESKTOP} {
    align-items: center;
    padding: ${SPACING.SM} ${SPACING.S32};
  }
`;

export const Text = styled.div`
  max-width: 800px;
  width: 100%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
`;

export const CloseBtn = styled.button`
  outline: none;
  border: none;
  background: none;
  padding: 0;
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
`;
